<template>
  <div class="openAccountForm" v-loading.fullscreen.lock="sonLoading">
    <!-- 境内 -->
    <div class="info-center" v-if="location == 'TERRITORY'">
      <div class="kyc-icon"></div>
      <div
        class="title"
      >
      {{ $t('kycFile.openAccountForm.tit') }}
      </div>
      <div>
        <div class="upload-down">
          <div class="com-word" >
             {{ $t('kycFile.openAccountForm.subTip') }}
          </div>
          <div
            class="down-word"
            @click="downloadTemp"
          >
             {{ $t('kycFile.openAccountForm.downText') }}
          </div>
        </div>
        <kycUpload
          v-if="mediaId"
          :mediaId="mediaId"
          modelCode="MKJ03CONTRACT"
          catgId="CCONTRACT001"
          :limit="1"
        ></kycUpload>
        <div class="item-check">
          <lls-checkbox v-model="checkedAuth"></lls-checkbox>
          <div class="check-word">
            <!-- 通过勾选此框及点击“提交”，您同意签署 -->
            {{ $t("kycFile.openAccountForm.tip") }}
            <span @click="openService" style="cursor: pointer;"
              > {{ $t("kycFile.openAccountForm.agreement") }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 境外 -->
    <div class="info-center" v-else>
      <div class="kyc-icon"></div>
      <div
        class="title"
      >
         {{ $t('kycFile.openAccountForm.titTwo') }}
      </div>
      <div>
       <div class="upload-down">
          <div class="com-word">
             {{ $t('kycFile.openAccountForm.subTip') }}
          </div>
          <div
            class="down-word"
            @click="downloadTemp"
          >
             {{ $t('kycFile.openAccountForm.downText') }}
          </div>
        </div>
        <kycUpload
          v-if="mediaId"
          :mediaId="mediaId"
          modelCode="MKJ03CONTRACT"
          catgId="CCONTRACT001"
          :limit="1"
        ></kycUpload>
      </div>
    </div>
  </div>
</template>

<script>
import kycUpload from "./kycUpload.vue";
export default {
  name: "openAccountForm",
  components: { kycUpload },
  data() {
    return {
      checkedAuth: false,
      enterpriseId: sessionStorage.getItem("enterpriseId"),
      mediaId: '',
      location: sessionStorage.getItem("location"),
      sonLoading: false,
    };
  },
  mounted() {
    this.getEnterprise()
  },
  methods: {
    async nextSon() {
      const query = {
        enterpriseId: this.enterpriseId,
        mediaId: this.mediaId,
      };
      // 境内
      if (this.location === "TERRITORY") {
        if (!this.checkedAuth) {
          this.$message.error(
            this.$t("kycFile.openAccountForm.checkServiceAgreement")
          );
          return;
        }
      }
      this.sonLoading = true;
      try {
        const res = await this.$API.kycFile.ekycSubmit(query, {});
        const { data, code, message } = res.data;
        if (code === "200" || data) {
          await this.claimAndCompleteTaskByBusId();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
      } finally {
        this.sonLoading = false;
      }
    },
    // 提交成功调用工作流
    async claimAndCompleteTaskByBusId() {
      this.sonLoading = true;
      try {
        await this.$API.kycFile.claimAndCompleteTaskByBusId(
          this.enterpriseId,
          {}
        );
        this.$emit("toNext");
      } catch (error) {
      } finally {
        this.sonLoading = false;
      }
    },
    async downloadTemp() {
      this.sonLoading = true;
      try {
        await this.$API.kycFile.downAccountAgreement(this.enterpriseId, {});
      } catch (error) {
        this.$message.error("Download failure");
      } finally {
        this.sonLoading = false;
      }
    },
    openService() {
      try {
        window.open("http://www.cfca.com.cn/20150811/101230094.html");
      } catch (error) {
      }
    },
    async getEnterprise() {
      this.sonLoading = true;
      try {
          const { data } = await this.$API.kycFile.getEnterprise(this.enterpriseId);
        if(data?.data) {
          this.mediaId = data?.data.mediaId || this.enterpriseId
        }
      } finally {
          this.sonLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../kycCommon.scss";
.openAccountForm {
  width: 100%;
  height: 100%;
  white-space: normal;
  .info-center {
    width: 720px;
    margin: 0 auto;
    .kyc-icon {
      width: 44px;
      height: 44px;
      background: url("~@/static/kjaccSonImg/kycIcon.png") center center
        no-repeat;
      margin: 0 auto;
    }
    .title {
      color: rgba(46, 90, 153, 1);
      text-align: center;
      padding: 14px 0 26px 0;
      line-height: 24px;
      font-weight: 600;
      font-size: 20px;
    }
    .eng-tip {
      font-size: 12px;
      line-height: 20px;
      color: #89929e;
    }

    .item-check {
      width: 720px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 15px 0px;
      .check-word {
        font-size: 12px;
        line-height: 16px;
        color: #333333;
        margin-left: 8px;
        margin-top: 3px;
        span {
          color: #3e8cfa;
        }
      }
    }
    .upload-down {
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 20px;
      .com-word {
        font-weight: 600;
        color: rgba(46, 90, 153, 1);
      }
      .down-word {
        color: #3e8cfa;
        margin-left: 20px;
        cursor: pointer;
        border: 1px solid #3e8cfa;
        border-radius: 4px;
        padding: 0 24px;
      }
    }
  }
}
</style>
